import * as React from "react";
import { useState } from "react";
import { useParams, useSearchParams, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { Formik, Form, FormikValues } from "formik";
import { Button, Box } from '@mui/material'
import axiosInstant from "../../../api";
import { CreateProjectFormProps as formProps } from "./helper";
import { FieldText } from "../../../components/fields/Text/Text";
import { useUser } from "../../../hooks/useUser";
import { MainContainer } from "../../../components/ContentWrapper";
import { handleConflictError } from "../../../utils/errorHandler";
import { usePortalPath } from '../../../hooks/usePortalPath'

export const CreateProject = () => {
  const { brandId: id } = useParams();
  const [ urlSearchParams, setUrlSearchParams ] = useSearchParams();
  const { user } = useUser();
  const [brandId, setBrandId] = useState("");
  const navigate = useNavigate();
  const { p } = usePortalPath();

  React.useEffect(() => {
    const profileBrandId = user?.brand?.[0]?.id;
    setBrandId(profileBrandId || id);
  }, [user]);


  const handleSubmit = async (values: FormikValues) => {
    
    values.newGroup = 'true';
    values.group = urlSearchParams.get('groupId');

    if(values.group) {
      values.newGroup = 'false';
    }

    try {
      const response = await axiosInstant.post(
        `/brands/${brandId}/projects`,
        values
      )
      toast.success("Project created successfully.");

      if(values.newGroup === 'true') {
        navigate(p(`/brands/${brandId}/projects/${response?.data?.id}/group/${response?.data?.projectGroups[0].id}`));
      } else {
        navigate(p(`/brands/${brandId}/projects/${response?.data?.id}/group/${values.group}/distribution`));
      }

    } catch (e: any) {
      if (!handleConflictError(e)) {
        toast.error("Something went wrong. Please verify again.");
      }
    }
  };

  return (
    <MainContainer title="New Distribution">
      <div className="bg-surface rounded-3xl box-shadow-1 ">
        <Formik {...formProps} onSubmit={handleSubmit}>
          <Form className="w-full gap-4 flex flex-col">
            <FieldText
              fullWidth
              label="Name"
              placeholder="Project Name"
              name="title"
            />
            <Box>
            <Button
              style={{ float: 'right' }}
              variant="contained"
              type="submit"
            >
              Next
            </Button>
            </Box>
            {/* <button
              
              className="justify-end bg-primary text-base text-white mx-auto py-3 px-5 lg:px-10 block rounded-xl focus:outline-none focus:shadow-outline"
              type="submit"
            >
              Submit
            </button> */}
          </Form>
        </Formik>
      </div>
    </MainContainer>
  );
};
